var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.21999 10.7705C3.51331 11.0765 3.98888 11.0765 4.28221 10.7705L8.00001 6.89176L11.7178 10.7705C12.0111 11.0765 12.4867 11.0765 12.78 10.7705C13.0733 10.4645 13.0733 9.9683 12.78 9.66228L8.53115 5.22951C8.35068 5.04123 8.10121 4.96879 7.86765 5.0122C7.72158 5.03933 7.58172 5.11177 7.46885 5.22953L3.21999 9.66229C2.92667 9.96831 2.92667 10.4645 3.21999 10.7705Z","fill":"#21A038"}));
}

ArrowUpInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
